import { useState, useEffect } from 'react';

import { formatTime } from '../../utils/time';

import styles from './LobbyPassBanner.module.scss';

interface CountdownTimerProps {
  startsInMs: number;
}

export const CountdownTimer = ({ startsInMs }: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState(startsInMs);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => Math.max(0, prev - 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return <span className={styles.timeCountdown}>{formatTime(timeLeft, 'ms')}</span>;
};
